var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDummyImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "30px",
    viewBox: "0 0 38 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / Photo@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v3---Documentation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy",
    transform: "translate(-255.000000, -97.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-49",
    transform: "translate(254.000000, 92.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Photo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "photo_size_select_actual-24px"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 40 0 40 40 0 40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35,5 L5,5 C3.33333333,5 1.66666667,6.66666667 1.66666667,8.33333333 L1.66666667,31.6666667 C1.66666667,33.5 3.16666667,35 5,35 L35,35 C36.6666667,35 38.3333333,33.3333333 38.3333333,31.6666667 L38.3333333,8.33333333 C38.3333333,6.66666667 36.6666667,5 35,5 Z M35,31.5333333 C34.9666667,31.5833333 34.9,31.6333333 34.8666667,31.6666667 L5,31.6666667 L5,8.46666667 L5.13333333,8.33333333 L34.85,8.33333333 C34.9,8.36666667 34.95,8.43333333 34.9833333,8.46666667 L34.9833333,31.5333333 L35,31.5333333 Z M18.3333333,25.85 L14.1666667,20.8333333 L8.33333333,28.3333333 L31.6666667,28.3333333 L24.1666667,18.3333333 L18.3333333,25.85 Z",
    id: "Shape",
    fill: "#D6D6D6"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDummyImg);
export default __webpack_public_path__ + "static/media/dummy_img.c241d3248eb0530650b4708050d47cd9.svg";
export { ForwardRef as ReactComponent };